import {Component, OnInit, inject} from '@angular/core';
import {filter, Subject, takeUntil} from "rxjs";
import {MsalBroadcastService, MsalService} from "@azure/msal-angular";
import {InteractionStatus} from "@azure/msal-browser";
import {NavigationComponent} from './navigation/navigation.component';
import {RouterOutlet} from '@angular/router';

@Component({
    selector: 'app-page',
    templateUrl: './page.component.html',
    styleUrl: './page.component.scss',
    imports: [NavigationComponent, RouterOutlet]
})
export class PageComponent implements OnInit {

    private msalService = inject(MsalService);
    private msalBroadcastService = inject(MsalBroadcastService);

    private readonly _destroying$ = new Subject<void>();

    ngOnInit(): void {
        // https://github.com/AzureAD/microsoft-authentication-library-for-js/issues/5155#issuecomment-1234471142
        // set active account - needs to be done manually for some reason
        this.msalBroadcastService.inProgress$
            .pipe(
                filter((status: InteractionStatus) => status === InteractionStatus.None),
                takeUntil(this._destroying$)
            )
            .subscribe(() => {
                const activeAccount = this.msalService.instance.getActiveAccount();

                if (!activeAccount && this.msalService.instance.getAllAccounts().length > 0) {
                    const accounts = this.msalService.instance.getAllAccounts();
                    this.msalService.instance.setActiveAccount(accounts[0]);
                }
            })
    }

}
